import { QueryClient } from '@tanstack/react-query';

/** App-wide React Query client with sensible defaults for a content site. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 2,
    },
  },
});
